import { render, staticRenderFns } from "./ShotsMgmt.vue?vue&type=template&id=c92d078a&scoped=true&"
import script from "./ShotsMgmt.vue?vue&type=script&lang=js&"
export * from "./ShotsMgmt.vue?vue&type=script&lang=js&"
import style0 from "./ShotsMgmt.vue?vue&type=style&index=0&id=c92d078a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92d078a",
  null
  
)

export default component.exports